// extracted by mini-css-extract-plugin
export var button = "_c1-2";
export var iconWrapper = "_c1-0";
export var investigatingIcon = "_c1-1";